/**
 * Below are the colors that are used in the app. The colors are defined in the light and dark mode.
 * There are many other ways to style your app. For example, [Nativewind](https://www.nativewind.dev/), [Tamagui](https://tamagui.dev/), [unistyles](https://reactnativeunistyles.vercel.app), etc.
 */

export const Colors = {
    content: "#fff",
    icon: '#687076',
    mainColor: "#ff3b6c",
    rippleColor: 'rgba(255, 30, 86, 0.2)',
    coloredShadow: 'rgba(255, 30, 86, 0.5)',
    coloredShadowTransparent: 'rgba(255, 30, 86, 0.2)',
    ratingOverlay: 'rgba(255, 30, 86, 0.3)',
    inputColor:"#fff",
    darkDivider: 'rgba(0, 0, 0, 0.2)',
    lightText: '#ffffff',
    transparent: 'transparent',
    semiTransparent: 'rgba(0, 0, 0, 0.5)',
    imageOverlay: 'rgba(0, 0, 0, 0.3)',
    transparentWhite: 'rgba(255, 255, 255, 0.7)',
    switchThumbOff: '#B7B7B7',
    switchThumbOn: "#ff1e56ff",
    placeholder: '#5E6062',
    paleGreen: '#ccf2e6',
    switchTrackOff: '#f0f0f0',
    ratingStar: '#FFFF5C',
    disabledBorder: '#d9d9d9',
    mainText: '#303030',
    tag: '#5E6062',
    subHeader: '#5E6062',
    unfocusedIcon: '#5E6062',
    weightLifting: ['#a096f5', '#9085f4','#8173f2', '#7162f1','#6150ef','#6150ef','#7162f1','#8173f2','#9085f4', '#a096f5'],
    crossFit: ['#ffb9ff','#ffadff', '#ffa1ff', '#ff96ff', '#ff8aff', '#ff8aff', '#ff96ff', '#ffa1ff', '#ffadff', '#ffb9ff'],
    cardio: ['#ffb9b9', '#ffadad', '#ffa1a1', '#ff9696', '#ff8a8a', '#ff8a8a', '#ff9696', '#ffa1a1', '#ffadad', '#ffb9b9'],
    boxing: ['#f2a7be','#e96d93', '#e55883', '#e24374', '#df2e64', '#df2e64', '#e24374', '#e55883', '#e96d93', '#f2a7be'],
    yoga: ['#b6dda9', '#86c76f', '#75bf5a', '#63b746', '#52af31', '#52af31', '#63b746', '#75bf5a', '#86c76f', '#b6dda9'],
    pilates: ['#8dd1c7', '#7acabe', '#67c2b5', '#54bbab', '#41b3a2', '#41b3a2', '#54bbab', '#67c2b5', '#7acabe', '#8dd1c7'],
    karate: ['#ebcdb3', '#e8c5a6', '#e5bd99', '#e1b48d', '#deac80', '#deac80', '#e1b48d', '#e5bd99', '#e8c5a6', '#ebcdb3'],
    bjj: ['#fcd78c', '#fcd079', '#fbc965', '#fbc352', '#fabc3f', '#fabc3f', '#fbc352', '#fbc965', '#fcd079', '#fcd78c'],
    kickboxing: ['#dd8a97', '#d77785', '#d16374', '#cc5062', '#c63c51', '#c63c51', '#cc5062', '#d16374', '#d77785', '#dd8a97'],
    other: ['#adbfff', '#9fb5ff','#91aaff', '#84a0ff', '#7695ff', '#7695ff', '#84a0ff', '#91aaff', '#9fb5ff', '#adbfff'],
    swim: ['#8cc5ff', '#79bcff', '#65b2ff', '#52a9ff', '#3f9fff', '#3f9fff', '#52a9ff', '#65b2ff', '#79bcff', '#8cc5ff'],
    green: "#34a853",
    muaiThai: ['#f2a7ac', '#e96d74', '#e55860', '#e2434c', '#df2e38', '#df2e38', '#e2434c', '#e55860', '#e96d74', '#f2a7ac'],
    mma: ['#ff9999', '#ff6666', '#ff4d4d', '#ff3333', '#ff1a1a', '#ff1a1a', '#ff3333', '#ff4d4d', '#ff6666', '#ff9999'],
    filterChips: {
      searchType: '#ff3b6c',
      price: '#00A86B',
      city: '#008CFF',
      rating: '#FFC107',
      specialty: '#FF007F',
    }
};

// CSS variables for use in CSS files
export const cssVariables = `
  :root {
    --color-content: ${Colors.content};
    --color-icon: ${Colors.icon};
    --color-mainColor: ${Colors.mainColor};
    --color-rippleColor: ${Colors.rippleColor};
    --color-coloredShadow: ${Colors.coloredShadow};
    --color-coloredShadowTransparent: ${Colors.coloredShadowTransparent};
    --color-ratingOverlay: ${Colors.ratingOverlay};
    --color-inputColor: ${Colors.inputColor};
    --color-darkDivider: ${Colors.darkDivider};
    --color-lightText: ${Colors.lightText};
    --color-transparent: ${Colors.transparent};
    --color-semiTransparent: ${Colors.semiTransparent};
    --color-imageOverlay: ${Colors.imageOverlay};
    --color-transparentWhite: ${Colors.transparentWhite};
    --color-switchThumbOff: ${Colors.switchThumbOff};
    --color-switchThumbOn: ${Colors.switchThumbOn};
    --color-placeholder: ${Colors.placeholder};
    --color-paleGreen: ${Colors.paleGreen};
    
  }
`;

export type Specialty = "weightLifting" | "crossFit" | "cardio" | "boxing" | "yoga" | "pilates" | "mma" | "karate" | "bjj" | "kickboxing" | "other" | "swim" | "muaiThai";

export const specialtyColors: Record<Specialty, string[]> = {
  weightLifting: Colors.weightLifting,
  crossFit: Colors.crossFit,
  cardio: Colors.cardio,
  boxing: Colors.boxing,
  yoga: Colors.yoga,
  pilates: Colors.pilates,
  mma: Colors.mma,
  karate: Colors.karate,
  bjj: Colors.bjj,
  kickboxing: Colors.kickboxing,
  other: Colors.other,
  swim: Colors.swim,
  muaiThai: Colors.muaiThai,
};

export const specialtyName: Record<Specialty, string> = {
  weightLifting: 'Weightlifting',
  crossFit: 'Crossfit',
  cardio: 'Cardio',
  boxing: 'Boxing',
  yoga: 'Yoga',
  pilates: 'Pilates',
  mma: 'MMA',
  karate: 'Karate',
  bjj: 'BJJ',
  kickboxing: 'Kickboxing',
  swim: 'Swimming',
  muaiThai: 'Muai Thai',
  other: 'Other',
};
